import { decryptAES } from "../encryption/CryptoService";
import Toast from "@moltech/molui/toast";

export const transformSuccessResponse = async (response, meta) => {
    let resData = decryptAndParse(response);

    ensureAuthStatusCode(resData, meta);

    if (!isSuccessResponse(resData)) {
        Toast.error(resData.message || "Something went wrong with API. Please contact admin!!");
        return null;
    }

    if (isAuthenticationUrl(meta)) {
        const authCheck = handleAuthFailure(resData);
        if (!authCheck) return null;
    }

    const data = extractResponseData(resData);
    return Array.isArray(data) ? data : resData;
};

export const transformErrorResponse = (response) => {
    if (response.status === "FETCH_ERROR") return handleFetchError();

    if (response.status === "PARSING_ERROR" && response.originalStatus === 500) {
        return handleParsingError(response);
    }

    if (response.status && response.data?.errors) {
        const resData = processResponseData(response);
        handleStatusErrors(response, resData);
    }

    return null;
};

const decryptAndParse = (data) => {
    let res = data;
    if (res.isEnType) res = decryptAES(res);
    return typeof res === "string" ? JSON.parse(res) : res;
};

const ensureAuthStatusCode = (apiData, meta) => {
    if (apiData.statusCode || !isAuthenticationUrl(meta)) return;

    const authFlag = apiData?.isAuthenticated ?? apiData?.responseItem?.responseContent?.isAuthenticated;
    if (authFlag !== undefined) {
        apiData.statusCode = authFlag ? 200 : 401;
    }
};

const isAuthenticationUrl = (meta) => meta.request.url.includes("Authentication");

const isSuccessResponse = (apiData) => {
    apiData.statusCode === 200 || Array.isArray(apiData)
    // if (!apiData) return false;
    // if (apiData.statusCode && apiData.statusCode !== 200) return false;
    // if (apiData.success === false) return false;
    // if (Array.isArray(apiData) || typeof apiData === "object") return true;
    return true;
};

const handleAuthFailure = (apiData) => {
    const isAuth = apiData?.isAuthenticated ?? apiData?.responseItem?.responseContent?.isAuthenticated;
    const message = apiData?.message ?? apiData?.responseItem?.responseContent?.message;
    if (isAuth === false && message) {
        Toast.error(message);
        return false;
    }
    return true;
};

const extractResponseData = (apiData) => {
    if (apiData?.responseItem?.responseContent) {
        apiData.data = apiData.responseItem.responseContent;
    }
    return apiData.data;
};

const handleFetchError = () => {
    Toast.error("Oops! Error while fetching data from the server. Please try again later.");
    return null;
};

const handleParsingError = (response) => {
    const errorMessage = response.data.toLowerCase();
    const isDbError =
        errorMessage.includes("sql server") ||
        errorMessage.includes("connection") ||
        errorMessage.includes("provider");

    Toast.error(
        isDbError
            ? "Oops! There was an issue with the SQL Server or database connection. Please try again later and ensure that the SQL Server is configured correctly."
            : "Oops! There was an issue processing the server's response. Please try again later."
    );
    return null;
};

const processResponseData = (response) => {
    let resData = response.data;
    if (response.data.isEnType) {
        resData = decryptAES(resData);
    } else {
        resData = typeof resData === "string" ? JSON.parse(resData) : resData;
    }
    return resData;
};

const handleValidationError = (resData) => {
    let errorMessage = `Validation Error: ${resData.title}`;
    for (const fieldName in resData.errors) {
        if (resData.errors.hasOwnProperty(fieldName)) {
            errorMessage += `\n ${fieldName} : ${resData.errors[fieldName].join("\n")} `;
        }
    }
    Toast.error(errorMessage);
};

const handleStatusErrors = (response, resData) => {
    if (response.status === 400 && resData.errors) {
        handleValidationError(resData);
    } else if (response.status === 500) {
        Toast.error("Something went wrong with the API call! Please contact admin.");
    }
};
